// **************************************************
// Add Remove Counter
// **************************************************
const cartItemsList = document.querySelectorAll('.cart-product-list__item');

const setPriceInEuro = (text, value) => {
  // eslint-disable-next-line no-param-reassign
  text.innerText = new Intl.NumberFormat('sl-SI', { style: 'currency', currency: 'EUR' }).format(value);
};

// Update Price
const updatePrice = (item) => {
  const priceHtml = item.querySelector('.cart-product-list__total-price');
  if (!priceHtml) {
    return;
  }
  const price = priceHtml.closest('.cart-product-list__row').dataset.product_price;
  const dataItemPrice = parseFloat(price.replace(',', '.'));
  const quantity = parseInt(item.querySelector('.counter__input').value, 10);
  const totalPrice = dataItemPrice * quantity;
  priceHtml.setAttribute('data-total-price', totalPrice);
  setPriceInEuro(priceHtml, totalPrice);
};

cartItemsList.forEach((item) => {
  updatePrice(item);
});

// Update count
const itemCounter = (element, toggle, inputByKeyboard = false) => {
  const parentElem = element.closest('.counter');
  const parentListItem = element.closest('.cart-product-list__item');
  const inputElem = parentElem.querySelector('.counter__input');
  const minusButton = parentElem.querySelector('.counter__button-decrement');

  let currentVal = parseInt(inputElem.value, 10) || 1;

  if (currentVal >= 1) {
    if (inputByKeyboard) {
      inputElem.value = currentVal;
    } else {
      // eslint-disable-next-line
      inputElem.value = toggle ? ++currentVal : Math.max(1, --currentVal);
      minusButton.classList.toggle('is-disabled', currentVal <= 1);
    }
  }

  updatePrice(parentListItem);
};

// Event listener for counter input
document.querySelectorAll('.counter__input').forEach((inputElem) => {
  inputElem.addEventListener('input', (event) => {
    const value = parseInt(event.target.value, 10);
    const newValue = isNaN(value) || value < 1 ? 1 : value;

    event.target.value = newValue;
    event.target
      .closest('.counter')
      .querySelector('.counter__button-decrement')
      .classList.toggle('is-disabled', newValue <= 1);

    itemCounter(event.target, false, true);
  });

  inputElem.addEventListener('blur', (event) => {
    if (parseInt(event.target.value, 10) < 1) {
      event.target.value = 1;
    }
  });
});

const addRemoveItem = (item) => {
  item.remove();
};

attachEvent('.counter__button-increment', 'click', (ev) => {
  itemCounter(ev.target, true);
});

attachEvent('.counter__button-decrement', 'click', (ev) => {
  itemCounter(ev.target, false);
});

// Delete Item
attachEvent('.cart-product-list__delete', 'click', (ev) => {
  const parentElem = ev.target.closest('.cart-product-list__item');
  addRemoveItem(parentElem);
});

attachEvent('input.counter__input', 'input', (ev) => {
  itemCounter(ev.target, false, true);
});

// **************************************************

document.querySelectorAll('.counter__input').forEach((counterInput) => {
  const minusBtn = counterInput.closest('.counter').querySelector('.counter__button-decrement');
  const currentVal = parseInt(counterInput.value, 10) || 1;
  if (currentVal === 1) {
    minusBtn.classList.add('is-disabled');
  }
});
